import { Calendar, ChevronRight } from 'lucide-react';

import './news-and-media-card.scss';

const className = 'news-and-media-card';
const NewsAndEventsCard = (props) => {
	const {
		title,
		image_URL,
		post_date,
		permalink,
		excerpt,
		event_date,
		media,
	} = props;
	let image_class = `${className}__image`;
	if (image_URL && image_URL.includes('fallback')) {
		image_class = `${className}__image--fallback`;
	}

	return (
		<div className={className}>
			<div className={`${className}__image-wrap`}>
				{event_date && (
					<span className={`${className}__event-date`}>
						<Calendar size={24} />
						{event_date}
					</span>
				)}
				<a href={permalink}>
					<img className={image_class} alt={title} src={image_URL} />
				</a>
			</div>
			<article className={`${className}__article`}>
				<div className={`${className}__meta`}>
					<h6 className={`${className}__post-date`}>{post_date}</h6>
					<span dangerouslySetInnerHTML={{ __html: media }}></span>
				</div>
				<h6 className={`${className}__headline`}>{title}</h6>
				<p
					className={`${className}__excerpt`}
					dangerouslySetInnerHTML={{ __html: excerpt }}
				></p>
				<a href={permalink} className={`${className}__link`}>
					Learn more
					<ChevronRight
						className={`${className}__link-icon`}
						size={24}
					/>
				</a>
			</article>
		</div>
	);
};
export default NewsAndEventsCard;
